var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgOpenEye(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 22,
    viewBox: "0 0 24 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9603 2.93945C14.1559 2.93945 15.973 4.79581 15.973 6.96155C15.973 9.20465 14.1559 11.061 11.9603 11.061C9.84047 11.061 8.02344 9.20465 8.02344 6.96155C8.02344 4.79581 9.84047 2.93945 11.9603 2.93945ZM11.9603 4.33172C10.5219 4.33172 9.38621 5.49194 9.38621 6.96155C9.38621 8.43117 10.5219 9.66874 11.9603 9.66874C13.3988 9.66874 14.6102 8.43117 14.6102 6.96155C14.6102 5.56929 13.3988 4.33172 11.9603 4.33172Z",
    fill: "#62646F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3344 6.96133C21.3502 5.64641 20.2145 4.56354 19.0032 3.71271C14.6877 0.618785 9.23659 0.618785 4.92114 3.71271C3.70978 4.56354 2.64984 5.64641 1.66562 6.96133C2.64984 8.35359 3.70978 9.43646 4.92114 10.2873C9.23659 13.3812 14.7634 13.3812 19.0032 10.2873C20.2145 9.43646 21.3502 8.35359 22.3344 6.96133ZM19.7603 2.55249C21.5773 3.79006 22.7886 5.25967 24 6.96133C22.7886 8.74033 21.5773 10.2099 19.7603 11.4475C15.0662 14.8508 8.93375 14.8508 4.16404 11.4475C2.42271 10.2099 1.21136 8.74033 0 6.96133C1.21136 5.25967 2.42271 3.79006 4.16404 2.55249C8.93375 -0.850829 14.9905 -0.850829 19.7603 2.55249Z",
    fill: "#62646F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOpenEye);
export default __webpack_public_path__ + "static/media/OpenEye.3fbe1e341fee1d922e2e90a53d236671.svg";
export { ForwardRef as ReactComponent };